import { DATA_01 } from '../../mocks/trading-quantities.data';
import { injectable } from 'inversify';
import { ITradingQuantitiesService } from './trading-quantities.interface';
import { Observable, of } from 'rxjs';

@injectable()
export class TradingQuantitiesMock implements ITradingQuantitiesService {
    get(): Observable<Array<number>> {
        return of(DATA_01.default.values);
    }
}
